import { EntityOption } from './types';

export const SEVEN_DAYS_IN_MS = 604800000;
export const INPUT_TYPES = {
	DATETIME_LOCAL: 'datetime-local'
};

export const FORMATS: {
	[key: string]: string;
} = {
	[INPUT_TYPES.DATETIME_LOCAL]: 'yyyy-MM-dd HH:mm:ss'
};

export const GAME_OPTIONS: EntityOption[] = [
	{
		label: 'LUDO',
		id: 'ludo'
	},
	{
		label: 'NINJA',
		id: 'ninja'
	},
	{
		label: 'SNLT',
		id: 'snlt'
	},
	{
		label: 'TURBO',
		id: 'turbo'
	},
	{
		label: 'TC',
		id: 'tc'
	},
	{
		label: 'LUDO SUPREME LEAGUE',
		id: 'ludonx'
	},
	{
		label: 'HC',
		id: 'hc'
	},
	{
		label: 'ZUPEE 11',
		id: 'zupee11'
	}
];
